<template>
    <TotemButton
        @click="toggleLoginMenu"
        class="logout-menu"
        color="primary"
        :label="$t('Menu.log_out')"
        :fullWidth="true"
        iconPosition="right"
        icon="exit"
    />
</template>
<script>
    export default {
        name: 'totem-button-sidebar-logout',
        methods: {
            toggleLoginMenu() {
                this.$store.dispatch('logout')
                this.$router.push({ name: 'home' })
                this.$store.dispatch('toggleSidebar')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .totem-button {
        &.logout-menu {
            display: flex;
            width: 94%;
            height: 45px !important;
            align-items: center;
            justify-content: center;
            padding: 0 27px;
            margin: 30px auto;
        }
    }
</style>
